var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3351 1.19808C11.3351 1.08534 11.3018 0.981194 11.2475 0.888672L6.89062 3.99527L11.2425 7.1109C11.2995 7.01665 11.3351 6.90864 11.3351 6.79245V1.19808Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57958 3.85603C5.8315 4.04755 6.17107 4.04799 6.42343 3.85647L10.8911 0.490672C10.8162 0.461547 10.7357 0.444336 10.6507 0.444336H1.35324C1.26824 0.444336 1.1881 0.461547 1.11328 0.490672L5.57958 3.85603Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.755553 0.888672C0.701269 0.981194 0.667969 1.08577 0.667969 1.19851V6.79288C0.667969 6.90907 0.703094 7.01665 0.760115 7.1109L5.11241 3.9957L0.755553 0.888672Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63148 4.44434C6.43887 4.56615 6.22141 4.63022 6.00261 4.63022C5.78382 4.63022 5.56636 4.56615 5.37375 4.44434L1.11328 7.51456C1.18518 7.53985 1.26151 7.55545 1.34273 7.55545H10.6625C10.7433 7.55545 10.8196 7.53985 10.8911 7.51498L6.63148 4.44434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letterIcon.590663216307ca84851acbabc13506fe.svg";
export { ForwardRef as ReactComponent };